import { memo } from "react";
const Container = ({
  children,
  height,
  className = "px-5 lg:px-11 elementFadeIn",
}) => {
  return <div className={className + " " + height}>{children}</div>;
};

export default memo(Container);

